import React, { createContext, useContext } from 'react';

import { type ProgressiveFieldEditRevealResult } from './use-backend-agent-field-edit-presence.ts';

const ProgressiveFieldEditRevealContext = createContext<
  ProgressiveFieldEditRevealResult | undefined
>(undefined);

export function ProgressiveFieldEditRevealProvider({
  children,
  result
}: {
  children: React.ReactNode;
  result: ProgressiveFieldEditRevealResult;
}) {
  return (
    <ProgressiveFieldEditRevealContext.Provider value={result}>
      {children}
    </ProgressiveFieldEditRevealContext.Provider>
  );
}

export function useProgressiveFieldEditRevealContext():
  | ProgressiveFieldEditRevealResult
  | undefined {
  return useContext(ProgressiveFieldEditRevealContext);
}
